// extracted by mini-css-extract-plugin
export default {"tariff":"tariff_tariff__yY55G"};